import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { QueueService } from '../../../../../common/services/Queue.service';
import { UserService } from '../../../../../common/services/User.service';
import { GroupService } from '../../../../../common/services/Group.service';

import * as _ from 'lodash';

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'queue-agent',
  templateUrl: './queue_agent.component.html',
  styleUrls: ['./queue.css'],
  providers: [QueueService, BsModalService, UserService, GroupService, BsModalRef],
})
@Injectable()
export class QueueAgentComponent implements OnInit {
  public queue_id: any;
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();

  public currentPage = 1;
  public totalRow = 0;
  public page_size = 10;
  public message: { class: string; content: string } = null;
  public list: any = [];
  public model: any = {};
  public typeModal: string;
  public modalRef: any = {};
  public modalRef2: any = {};
  public types: any = [];
  totalItem: any = 0;
  totalPage: any = 0;

  public id_delete: number;
  public allRoom: any = [];
  public modelFilter: any = {};
  public actionParam: any = 'add';
  public agent_id: any;
  public options_in_queue: any = [];
  public is_load_data = true;

  public options: any = {};
  public lstChecked: any = [];
  public isCheckAll = false;
  public agentInQueue: any = [];

  constructor(
    private queueService: QueueService,
    private modalService: BsModalService,
    private userService: UserService,
    private groupService: GroupService,
    public bsModalRef: BsModalRef,
    private toastr: ToastrService
  ) {
    this.options_in_queue = [
      {
        text: 'Trạng thái',
        id: '0',
      },
      {
        text: 'Trong hàng đợi',
        id: '1',
      },
      {
        text: 'Chưa gán vào hàng đợi',
        id: '2',
      },
    ];
  }

  ngOnInit() {
    this.is_load_data = true;
    this.modelFilter = {
      filter_agent_name: '',
      filter_agent_phone: '',
      filter_agent_email: '',
      room_id: '',
      is_in_queue: '0',
    };
    this.loadData(this.options);
    this.getRooms();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.is_load_data = false;
    }, 1500);
  }

  getRooms() {
    this.groupService.allGroup({ target: 'user' }).subscribe(res => {
      const roomList = [];
      res.data.forEach((c: any) => {
        roomList.push({
          text: c.name,
          id: c.id.toString(),
        });
      });
      this.allRoom = roomList;
    });
  }

  filterAgent() {
    this.options = {};
    const filters = [];
    if (this.modelFilter.filter_agent_phone) {
      filters.push({
        key: 'phone',
        condition: '=',
        value: this.modelFilter.filter_agent_phone,
      });
    }
    if (this.modelFilter.filter_agent_email) {
      filters.push({
        key: 'email',
        condition: '=',
        value: this.modelFilter.filter_agent_email,
      });
    }
    if (this.modelFilter.filter_agent_name) {
      filters.push({
        key: 'name',
        condition: '=',
        value: this.modelFilter.filter_agent_name,
      });
    }
    if (this.modelFilter.room_id) {
      filters.push({
        key: 'group_id',
        condition: '=',
        value: this.modelFilter.room_id,
      });
    }

    if (this.modelFilter.is_in_queue != '0') {
      this.options['in_queue'] = this.modelFilter.is_in_queue == '1';
      this.options['queue_id'] = this.queue_id;
    }
    this.options['filters'] = JSON.stringify(filters);
    this.loadData(this.options);
  }

  loadData(request: any = {}, sort: any = {}) {
    this.list = [];
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }
    this.userService.list(request).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.list = res.data.list;
        this.totalItem = res.data.total;
        const pageString = (this.totalItem / this.page_size).toString();
        const pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalPage = totalpage;
        this.queueService.agentInQueue(this.queue_id).subscribe(res => {
          if (res.status == 200 && res.error == false) {
            this.agentInQueue = res.data;
            this.list = _.map(this.list, e => {
              const check = _.find(this.agentInQueue, { AGENT_ID: e.agent_id });
              if (check) {
                e.in_queue = true;
                e.priority = check.PRIORITY;
              }
              return e;
            });
          }
        });
      } else {
        this.list = [];
      }
    });
  }

  add() {
    if (!this.model.PRIORITY) {
      this.toastr.error('Mức ưu tiên không được bỏ trống', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      this.queueService
        .addAgent(this.queue_id, {
          AGENT_ID: this.agent_id,
          PRIORITY: this.model.PRIORITY,
        })
        .subscribe(
          res => {
            if (res) {
              const error = res.error;
              if (error) {
                this.message = {
                  class: 'alert dark alert-danger',
                  content: 'Lưu không thành công',
                };
                this.toastr.error('Lưu thất bại', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
                this.modalRef2.hide();
              } else {
                this.message = {
                  class: 'alert dark alert-success',
                  content: 'Cập nhật thành công',
                };
                this.toastr.success('Cập nhật thành công', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
                this.modalRef2.hide();
                this.loadData(this.options);
              }
            }
          },
          error => {
            this.message = {
              class: 'alert dark alert-danger',
              content: error.message,
            };
          }
        );
    }
  }

  deleteOutQueue(agent_id) {
    this.queueService.deleteAgent(this.queue_id, agent_id).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Xóa không thành công',
            };
            this.toastr.error('Xóa thất bại', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-success',
              content: 'Xóa thành công',
            };
            this.toastr.success('Xóa thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });

            this.loadData({ queue_id: this.queue_id });
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  public changedFilterRoom(e: any): void {
    if (!this.is_load_data) {
      this.modelFilter.room_id = e.value;
    }
  }

  public changedFilterOption(e: any): void {
    if (!this.is_load_data) {
      this.modelFilter.is_in_queue = e.value;
    }
  }

  openModal(template: TemplateRef<any>, agent?: any, type?: any) {
    this.actionParam = type;
    this.model.PRIORITY = 1;
    this.agent_id = agent ? agent.agent_id : null;
    if (!this.agent_id) {
      this.toastr.error('Chuyên viên chưa được cấu hình mã chuyên viên', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }
    this.message = null;
    if (type == 'edit') {
      this.model = {
        PRIORITY: agent.priority,
      };
      console.log(this.model);
    }
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.modalRef2 = this.modalService.show(template, config);
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData(this.options);
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData(this.options);
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  refreshFilter() {
    this.modelFilter = {
      filter_agent_name: '',
      filter_agent_phone: '',
      filter_agent_email: '',
      room_id: '',
      is_in_queue: '0',
    };
    this.filterAgent();
  }
  checkRow(type: any, _id?: any) {
    if (type == 'all') {
      if (!this.isCheckAll) {
        this.list.forEach(row => {
          if (!this.lstChecked.includes(row.agent_id)) {
            this.lstChecked.push(row.agent_id);
          }
        });
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
        this.lstChecked = [];
      }
    }
    if (type == 'row') {
      if (this.lstChecked.includes(_id)) {
        this.lstChecked = this.lstChecked.filter(item => item !== _id);
      } else {
        this.lstChecked.push(_id);
      }
    }
  }
  addIntoQueues() {
    this.queueService.addManyAgents(this.queue_id, { agent_ids: this.lstChecked, PRIORITY: 1 }).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Lưu không thành công',
            };
            this.toastr.error('Lưu thất bại', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-success',
              content: 'Cập nhật thành công',
            };
            this.toastr.success('Cập nhật thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.loadData({ queue_id: this.queue_id });
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }
  deleteOutQueues() {
    this.queueService.deleteManyAgents(this.queue_id, { agent_ids: this.lstChecked }).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Xóa không thành công',
            };
            this.toastr.error('Xóa thất bại', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-success',
              content: 'Xóa thành công',
            };
            this.toastr.success('Xóa thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.loadData({ queue_id: this.queue_id });
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/queue/queue_agent.component.ts